import Modal from "./views/modal";
import BulkModal from "./views/bulk_modal";

import _ from "underscore";
import $ from "jquery";

function customDataRowRenderer(node, { attr }) {
  const customData = this.model.get(attr);
  let linkText;
  if (customData) {
    linkText = 'Applied';
  } else {
    linkText = 'Apply';
  }
  const applyLink = $(`<a href="#" class="edit-custom-data-modal">${linkText}</a>`);
  node.html("").append(applyLink).addClass('link_cursor');
}

const editCustomDataModal = (event, { customData, urlConfig }, dataOwnerType, row) => {
  event.preventDefault();

  const dataOwnerPayload = {
    data_owner_type: dataOwnerType,
    data_owner_id: row.model.attributes.id
  };

  const customDataConfig = $.extend({}, customData, urlConfig, { row, payloadParams: dataOwnerPayload });
  const dialog = new Modal(customDataConfig);
  dialog.render();
};

const editCustomDataModalBulk = (
  models,
  { customData, urlConfig },
  dataOwnerType,
  dataTable,
  showFields,
  callerMessage
) => {
  const dataOwnerPayload = {
    data_owner_type: dataOwnerType,
    data_owner_ids: _.pluck(models, "id")
  };

  if (_.isUndefined(showFields)) {
    showFields = true;
  }

  if (_.isUndefined(callerMessage)) {
    callerMessage = null;
  }

  const customDataConfig = $.extend({}, customData, urlConfig, { dataTable, payloadParams: dataOwnerPayload, showFields, callerMessage });
  const dialog = new BulkModal(customDataConfig);
  dialog.render();
};

const bulkActionDropdownTitle = () => "Apply Marketing Data";

export default {
  customDataRowRenderer,
  editCustomDataModal,
  editCustomDataModalBulk,
  bulkActionDropdownTitle
};
